import { EmptyHistory } from "../../styled";

export default function EmptyHistoryDisplay({ message }) {
    return <EmptyHistory>{message}</EmptyHistory>;
}